/*
  ============================================================
  carrinho.js — Helper de carrinho (add-to-cart via AJAX)
  ============================================================

  O QUE FAZ:
  Melhoria progressiva para adicionar produtos ao carrinho sem
  recarregar a pagina. Intercepta o envio de qualquer formulario
  de add-to-cart, envia para a Cart AJAX API do Shopify
  (/cart/add.js), atualiza o contador do carrinho no header
  (buscando /cart.js) e mostra uma confirmacao leve via
  window.mostrarAlerta (definido em snippets/alerta.liquid).

  OBSERVACOES:
  Funciona sem JS: o formulario de produto ja envia nativamente
  para /cart/add. O contador usa elementos com [data-cart-count].
  Os textos dos alertas vem de window.themeStrings, definido em
  layout/theme.liquid a partir de locales/pt-BR.default.json.

  SUMMER: duas correcoes neste arquivo, registradas em
  docs/alteracoes-tema-base.md.

  1) Falha do add-to-cart passa a avisar na propria vitrine. O
     catch chamava form.submit(), refazendo o POST nativo — numa
     falha real (variante esgotada, limite de estoque) o cliente
     saia da vitrine e caia na pagina de erro crua da Shopify, em
     ingles, apesar de o tema ja publicar o texto em portugues em
     window.themeStrings.addToCartError. Agora esse texto vai para
     o toast negativo de snippets/alerta.liquid, o mesmo que o
     caminho de sucesso ja usa com o tipo positivo. O form.submit()
     sobrou so como ultimo recurso: sem o toast ou sem o texto de
     locale nao ha como avisar em portugues aqui, e o POST nativo
     ao menos leva o cliente a uma pagina que mostra o erro.

  2) Rota do carrinho unificada em cartUrl(). O add usava
     '/cart/add.js' cravado enquanto o contador ao lado ja usava
     window.Shopify.routes.root — numa storefront com prefixo de
     idioma (/pt-br/) os dois divergiam.
*/
(function () {
  'use strict';

  // routes.root ja termina em barra ('/' ou '/pt-br/'), entao basta concatenar.
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch(cartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* SUMMER: ids das sections de carrinho presentes na pagina.
     Sao as mesmas que assets/summer-cart.js repinta — ele as marca com
     [data-summer-cart-section]. Ler daqui evita cravar id de section no JS. */
  function idsDeSecaoDeCarrinho() {
    var els = document.querySelectorAll('[data-summer-cart-section]');
    var ids = [];
    for (var i = 0; i < els.length; i++) {
      var id = els[i].getAttribute('data-summer-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');

    /* SUMMER: o HTML do drawer vem NA MESMA resposta do add.

       Antes eram tres viagens em sequencia para um clique: POST /cart/add,
       depois GET /cart.js para o contador e GET /?sections= para repintar o
       drawer — e o drawer so abria quando a terceira voltava. Medido no dev
       server: 550ms ate abrir, 873ms ate o contador virar.

       A propria rota de add aceita `sections` e devolve o HTML ja renderizado,
       entao a segunda e a terceira viagem viram zero. `sections_url` aponta
       para a RAIZ pelo mesmo motivo documentado em summer-cart.js: em /cart a
       rota responde ao Accept: application/json com o carrinho em vez das
       sections.

       Nada disso e obrigatorio: sem section de carrinho na pagina (uma PDP sem
       drawer, por exemplo) o corpo vai como sempre foi e o contador volta a
       sair de /cart.js. O caminho antigo continua inteiro como reserva. */
    var corpo = new FormData(form);
    var idsSecoes = idsDeSecaoDeCarrinho();
    if (idsSecoes.length) {
      corpo.append('sections', idsSecoes.join(','));
      corpo.append('sections_url', cartUrl(''));
    }

    /* SUMMER: o drawer abre no CLIQUE, nao na resposta.

       O retorno do botao era instantaneo (aria-busy), mas a gaveta so
       aparecia quando o servidor respondia — perto de um segundo em rede
       ruim, tempo suficiente para o cliente clicar de novo achando que
       falhou. Agora ela abre no mesmo quadro do clique e se repinta quando o
       item chega; o rodape fica em aria-busy nesse intervalo, que e a regra
       ja documentada em summer-components.css (o rodape trava porque um
       segundo clique ali viraria um segundo checkout).

       DUAS GUARDAS, e as duas importam:
       - Em /cart nao abre: o conteudo ja esta a vista.
       - Com o carrinho VAZIO nao abre: a gaveta mostraria o estado "carrinho
         vazio" por um segundo justamente enquanto o primeiro item entra, que
         e o oposto do que o clique acabou de dizer. Nesse caso ela continua
         abrindo depois da resposta, ja com o item dentro. */
    var contador = document.querySelector('[data-cart-count]');
    var jaTemItem = contador && parseInt(contador.textContent, 10) > 0;
    if (idsSecoes.length && jaTemItem && window.location.pathname.indexOf('/cart') === -1) {
      document.querySelectorAll('[data-summer-cart-section]').forEach(function (el) {
        el.setAttribute('aria-busy', 'true');
      });
      document.dispatchEvent(new CustomEvent('summer:cart:open', {
        bubbles: true,
        cancelable: true
      }));
    }

    fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: corpo
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (dados) {
        var secoes = dados && dados.sections;

        /* Com as sections em maos quem atualiza o contador e a repintura —
           o numero vem no atributo data-summer-cart-total do HTML novo. Pedir
           /cart.js aqui seria uma terceira viagem para saber o que ja chegou. */
        if (!secoes) refreshCartCount();

        /* SUMMER: avisa quem estiver ouvindo que o carrinho mudou.
           assets/summer-cart.js escuta para repintar e abrir o drawer.
           O evento e emitido em vez de o drawer interceptar o submit por
           conta propria: dois interceptadores do mesmo submit fariam dois
           POST /cart/add e o item entraria em dobro. Ninguem ouvindo, nada
           acontece — o toast abaixo continua sendo o unico retorno. */
        document.dispatchEvent(new CustomEvent('summer:cart:changed', {
          bubbles: true,
          detail: { source: 'add', sections: secoes || null }
        }));

        if (typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(
            (window.themeStrings && window.themeStrings.addedToCart) || 'Added to cart',
            'positivo'
          );
        }
      })
      .catch(function () {
        var errorMessage = window.themeStrings && window.themeStrings.addToCartError;
        if (errorMessage && typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(errorMessage, 'negativo');
          return;
        }
        // Sem texto de locale ou sem o toast nao ha como avisar aqui:
        // fallback para o POST nativo, o comportamento antigo.
        form.submit();
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();
